// CMS-rollen. Een gebruiker krijgt zijn rol via `role` (accounts die alleen voor
// het CMS bestaan) óf via `cmsRole` (een bestaand webshopaccount dat daarnaast
// CMS-toegang krijgt — zie functions/permissions.js → getCmsRole). Wat een rol
// mag staat NIET hier: de standaard staat in functions/permissions.js en de
// werkelijke rechten in Firestore `cmsRoles/{roleId}` (Beheer → Rollen).
//
// Vaste set (BMX-36): namen en rechten zijn instelbaar, de set zelf niet — de
// Firestore-regels kennen deze vijf id's.
module.exports = {
  admin: "cmsAdmin",
  user: "cmsUser",
  sales: "cmsSales",
  employee: "cmsEmployee",
  purchasing: "cmsPurchasing",
};
